module.exports = __webpack_public_path__ + "static/Hind-Light-b78550d1e21c367f38af3cbf8a89625b.ttf";